<div class="m-[16px]">
  <div class="flex justify-between items-center">
    <div class="text-[#121212] font-bold text-[16px]">
      {{ date.toLocaleString('default', { month: 'long', year: 'numeric' }) }}
    </div>
    <div class="flex">
      <button (click)="decrementMonth()" class="w-[24px] h-[24px] flex items-center justify-center rounded-[8px] hover:bg-gray-200">
        <fa-icon [icon]="faChevronLeft"/>
      </button>
      <button (click)="incrementMonth()" class="w-[24px] h-[24px] flex items-center justify-center rounded-[8px] hover:bg-gray-200">
        <fa-icon [icon]="faChevronRight"/>
      </button>
    </div>
  </div>
  <div class="grid grid-cols-7 gap-[4px] text-[#121212] text-[12px] font-medium mt-[16px] text-center">
    <div>
      <b>Sun</b>
    </div>
    <div>
      <b>Mon</b>
    </div>
    <div>
      <b>Tue</b>
    </div>
    <div>
      <b>Wed</b>
    </div>
    <div>
      <b>Thur</b>
    </div>
    <div>
      <b>Fri</b>
    </div>
    <div>
      <b>Sat</b>
    </div>
  </div>
  @for (week of calendarDays; track week) {
    <div class="grid grid-cols-7 h-[34px] w-full text-[12px] mt-[4px] font-medium text-center">
      @for (calendarDay of week; track calendarDay; let i = $index) {
        <div [ngClass]="{
            'flex justify-center items-center': true,
            'bg-[#FAE6EB] !text-rutgers-red': (isSameDay(startDate ,calendarDay.date) || isSameDay(endDate ,calendarDay.date) || isBetweenDate(startDate, endDate, calendarDay.date)) && (startDate && endDate),
            'rounded-l-[6px]': isSameDay(startDate ,calendarDay.date) || i === 0,
            'rounded-r-[6px]': isSameDay(endDate ,calendarDay.date) || i + 1 === week.length
          }">
          <button (click)="toggleDate(calendarDay.date); $event.stopPropagation()" [ngClass]="{
            'w-full h-full transition overflow-hidden rounded-[6px]': true,
            'font-semibold': calendarDay.isCurrentMonth,
            'font-normal': !calendarDay.isCurrentMonth,
            'bg-[#F1B8C6] !text-rutgers-red': isSameDay(startDate ,calendarDay.date) || isSameDay(endDate, calendarDay.date),
            'hover:bg-gray-200': !isSameDay(startDate ,calendarDay.date) && !isSameDay(endDate ,calendarDay.date) && !isBetweenDate(startDate, endDate, calendarDay.date),
            'hover:bg-[#F1B8C6] !text-rutgers-red': isBetweenDate(startDate, endDate, calendarDay.date),
            '!rounded-l-[6px]': i === 0,
            '!rounded-r-[6px]': i + 1 === week.length
          }">
            {{calendarDay.dayNumber}}
          </button>
        </div>
      }
    </div>
  }
</div>
